let config = [{
  name: '新人报道',
  type: 'module-name'
},

{
  key: 'property_data',
  name: '属性',
  type: 'custom',
  content: [{
    key: 'head_img',
    name: '头像',
    type: 'choose-photo'
  },
  {
    key: 'offset_y',
    name: '头像偏移y轴',
    type: 'slider'
  },
  {
    key: 'offset_x',
    name: '头像偏移x轴',
    type: 'slider'
  },
  {
    key: 'scale',
    name: '头像缩放',
    type: 'slider'
  },
  {
    key: 'name',
    name: '姓名',
    type: 'text'
  },
  {
    key: 'department',
    name: '部门',
    type: 'text'
  },
  {
    key: 'subDepartment',
    name: '一级部门',
    type: 'text'
  },
  {
    key: 'property',
    name: '其他汇总',
    type: 'textarea'
  },
  {
    'key': 'font_key',
    'name': '选用字体',
    'type': 'select',
    'memo': '请选择字体',
    'option-list': [{
      'label': '方正兰亭圆_GBK_粗',
      'value': 'a'
    }, {
      'label': '方正兰亭圆_GBK_中',
      'value': 'b'
    }, {
      'label': '方正正大黑简体',
      'value': 'c'
    }, {
      'label': '濑户字体',
      'value': 'd'
    }, {
      'label': '杨任东竹石体-Bold',
      'value': 'e'
    }, {
      'label': '站酷庆科黄油体',
      'value': 'f'
    }],
    'required': true
  },
  {
    key: 'font_size',
    name: '属性字体大小',
    type: 'slider',
    min: 12,
    max: 24,
  },
  {
    key: 'nickname',
    name: '江湖称号',
    type: 'text'
  },
  {
    key: 'birthday',
    name: '生日',
    type: 'text'
  },
  {
    key: 'constellation',
    name: '星座',
    type: 'text'
  },
  {
    key: 'hometown',
    name: '籍贯',
    type: 'text'
  },
  {
    key: 'single',
    name: '单身吗',
    type: 'text'
  },
  {
    key: 'hobby',
    name: '兴趣爱好',
    type: 'text'
  },
  {
    key: 'specialty',
    name: '过人之处',
    type: 'text'
  }
  ]
}
];

export default config;
